import { Card } from "../ui/Card.jsx";
import { IconTile } from "../ui/IconTile.jsx";
import { SectionHeading } from "../ui/SectionHeading.jsx";
import { Icon } from "../ui/Icon.jsx";

export function Verticals() {
  const items = [
    {
      icon: <Icon.Store />,
      title: "E-commerce & DTC",
      body: "Find your highest-LTV shoppers, understand what drives repeat purchases, and engage lapsed customers before they churn.",
    },
    {
      icon: <Icon.Gear />,
      title: "Service contracting",
      body: "Spot renewal and upsell windows across every job history, and reach homeowners at the moment they're ready to book.",
    },
    {
      icon: <Icon.Code />,
      title: "Enterprise software",
      body: "See usage and health signals across every account, and act on churn risk or expansion opportunity before it's too late.",
    },
  ];

  return (
    <section className="section section-bg2" id="verticals">
      <div className="container">
        <SectionHeading eyebrow="Who it's for" title="Different industries. Same three problems." />
        <div className="grid-3">
          {items.map((it, i) => (
            <Card key={i} className="vertical-card" data-reveal>
              <IconTile icon={it.icon} />
              <h3>{it.title}</h3>
              <p>{it.body}</p>
            </Card>
          ))}
        </div>
        <p className="verticals-footnote">
          Also working well for automotive, hospitality, and financial services.
        </p>
      </div>
    </section>
  );
}
